import { forwardRef } from "react";
import { useId } from "react";
function SvgCanvasSvg({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="#fff" clipPath={`url(#CanvasSVG_svg__a${toAppend})`}>
        <path d="M17.831 1.226a3.881 3.881 0 0 1-7.662 0" />
        <path d="M14 4.485c1.93 0 3.53-1.407 3.831-3.253A13.237 13.237 0 0 0 14 .667c-1.33 0-2.616.198-3.831.559.3 1.846 1.9 3.26 3.831 3.26ZM14 23.52a3.881 3.881 0 0 0-3.831 3.254 13.414 13.414 0 0 0 7.662 0A3.881 3.881 0 0 0 14 23.52ZM7.27 7.27a3.88 3.88 0 0 0 .403-5.01A13.38 13.38 0 0 0 2.26 7.68a3.887 3.887 0 0 0 5.01-.409ZM20.73 20.73a3.88 3.88 0 0 0-.403 5.01 13.43 13.43 0 0 0 5.419-5.42 3.895 3.895 0 0 0-5.016.41ZM4.486 14c0-1.93-1.414-3.53-3.254-3.831a13.238 13.238 0 0 0-.565 3.83c0 1.33.198 2.617.559 3.832 1.846-.3 3.26-1.9 3.26-3.831ZM26.774 10.169a3.882 3.882 0 0 0 0 7.662 13.414 13.414 0 0 0 0-7.662ZM7.27 20.73a3.88 3.88 0 0 0-5.01-.403 13.401 13.401 0 0 0 5.413 5.412 3.88 3.88 0 0 0-.403-5.01ZM20.73 7.27a3.88 3.88 0 0 0 5.01.403 13.43 13.43 0 0 0-5.42-5.419 3.895 3.895 0 0 0 .41 5.016ZM15.227 6.843c0-.68-.547-1.227-1.227-1.227s-1.227.548-1.227 1.227c0 .68.547 1.227 1.227 1.227s1.227-.547 1.227-1.227ZM15.227 21.217a1.228 1.228 0 0 0-2.454 0c0 .68.547 1.227 1.227 1.227s1.227-.548 1.227-1.227ZM9.79 8.082a1.227 1.227 0 0 0-1.738 0 1.227 1.227 0 0 0 0 1.738 1.227 1.227 0 0 0 1.738 0 1.238 1.238 0 0 0 0-1.738ZM19.954 18.246a1.227 1.227 0 0 0-1.738 0 1.227 1.227 0 0 0 0 1.738 1.227 1.227 0 0 0 1.738 0 1.238 1.238 0 0 0 0-1.738ZM6.813 12.803c-.68 0-1.227.547-1.227 1.227s.547 1.227 1.227 1.227S8.04 14.71 8.04 14.03s-.547-1.227-1.227-1.227ZM21.187 12.803a1.228 1.228 0 0 0 0 2.454c.68 0 1.227-.547 1.227-1.227s-.548-1.227-1.227-1.227ZM8.052 18.246a1.227 1.227 0 0 0 0 1.738 1.227 1.227 0 0 0 1.738 0 1.227 1.227 0 0 0 0-1.738 1.227 1.227 0 0 0-1.738 0ZM18.216 8.082a1.227 1.227 0 0 0 0 1.738 1.227 1.227 0 0 0 1.738 0 1.227 1.227 0 0 0 0-1.738 1.227 1.227 0 0 0-1.738 0Z" />
      </g>
      <defs>
        <clipPath id={`CanvasSVG_svg__a${toAppend}`}>
          <path fill="#fff" d="M.667.667h26.667v26.667H.667z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCanvasSvg);
export default ForwardRef;
